module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-700-367.6158fd1.woff2";